import * as t from "io-ts";
import { Metadata } from "./Metadata";
import { RateKeys } from "./RateKeys";

export const RateRequest = t.intersection([
  t.type({
    requester: t.string,
    to_add: RateKeys,
    to_remove: RateKeys,
    added: RateKeys,
    removed: RateKeys,
  }),
  t.partial({
    metadata: Metadata,
  }),
]);

export interface RateRequest {
  requester: string;
  to_add: RateKeys;
  to_remove: RateKeys;
  added: RateKeys;
  removed: RateKeys;
  metadata?: Metadata;
}
